import React, { FC, useCallback } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import AccountAutocomplete from '../AccountAutocomplete';
import { Account, Employee, Terminal } from '~/types';
import { OatConsentData } from './OatConsentData';

interface SenderAccountProps {
  className?: string;
  setMainState: React.Dispatch<React.SetStateAction<OatConsentData>>;
  mainState: OatConsentData;

  loading?: boolean;
  accounts?: Account[];
  terminals?: Terminal[];
  employees?: Employee[];
}

const SenderAccount: FC<SenderAccountProps> = (props) => {
  const { setMainState, mainState, loading, accounts, terminals, employees } = props;
  const [t] = useTranslation('oat');

  const recipientAccountId = mainState.recipientAccount?.id;

  const onChange = useCallback(
    (senderAccount: Account | undefined) => {
      if (recipientAccountId && senderAccount?.id === recipientAccountId) {
        setMainState((prev) => ({
          ...prev,
          senderAccount,
          recipientAccount: undefined,
          recipientAccountReset: true,
        }));
      } else {
        setMainState((prev) => ({ ...prev, senderAccount }));
      }
    },
    [recipientAccountId, setMainState]
  );

  return (
    <div>
      <Typography.Title level={4}>{t('From account')}</Typography.Title>
      <AccountAutocomplete
        onChange={onChange}
        accountId={mainState.senderAccount?.id}
        loading={loading}
        accounts={accounts}
        terminals={terminals}
        employees={employees}
      />
    </div>
  );
};

export default SenderAccount;
